var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "component-small-class" },
    [
      _vm._m(0),
      _c("VideoPlayer", { attrs: { videos: _vm.videos, isPaid: _vm.isPaid } }),
      _vm._m(1),
      _c("p", { staticClass: "text1 color-gray-2 mt-10" }, [
        _vm._v(
          " 经济学是哈佛大学最富盛名的热门学科之一，而学好发展经济学能够帮助你更好地理解中国和世界经济发展背后的学术原理、以及我们身处的世界经济。在这堂课上，哈佛的Philip老师将带你走进发展经济学的世界。希望学完这堂课，当你阅读中英文财经新闻的时候，看到一些名词和概念就能给身边的小伙伴讲一讲啦！ "
        )
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("h1", { staticClass: "h1 color-gray-1" }, [
      _vm._v(" 富国穷国背后的经济学原理 "),
      _c("br", { staticClass: "m-only" }),
      _c("span", { staticClass: "color-gray-4" }, [
        _vm._v("Development Economics")
      ])
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("p", { staticClass: "text1 color-gray-2 mt-24" }, [
      _vm._v(" 为什么世界上有些国家富裕，而有些国家贫穷？"),
      _c("br"),
      _vm._v(" 为什么2019年诺贝尔经济学奖得主的研究，对改善全球贫困影响重大？"),
      _c("br"),
      _vm._v(
        " 发展经济学（Development Economics）主要研究的是经济发展欠发达的农业国家或发展中国家如何实现工业化、摆脱贫困、走向富裕的过程。 "
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }